/**
 * This file is auto-generated from HeroSection.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const heroHeading: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'GLP-1 Weight Loss Treatment';
        case 'pl':
            return 'Leczenie odchudzające GLP-1';
    }
};

export const heroSubtitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'See if you qualify for GLP-1 medication like Ozempic or Wegovy. Answer a few questions, get evaluated by a licensed physician, and receive your prescription — all online.';
        case 'pl':
            return 'Sprawdź, czy kwalifikujesz się do leczenia lekami GLP-1, takimi jak Ozempic czy Wegovy. Odpowiedz na kilka pytań, uzyskaj ocenę licencjonowanego lekarza i odbierz receptę — wszystko online.';
    }
};

export const heroCta: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Check your eligibility';
        case 'pl':
            return 'Sprawdź, czy się kwalifikujesz';
    }
};

export const portraitLicensedPhysician: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'A portrait of a licensed physician';
        case 'pl':
            return 'Portret licencjonowanego lekarza';
    }
};

export const helloName: Translation<{ name: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Hello ', params.name, '!'];
        case 'pl':
            return ['Witaj ', params.name, '!'];
    }
};

export const helloBack: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Welcome back!';
        case 'pl':
            return 'Witaj ponownie!';
    }
};

export const conversationStarted: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'You have a conversation started. You can continue it or start a new one. Physician will prepare a treatment plan and - if appropriate - an e-prescription and a sick note. If you only need a prescription renewal, tell us.';
        case 'pl':
            return 'Masz rozpoczętą rozmowę. Możesz ją kontynuować lub rozpocząć nową. Następnie lekarz przygotuje plan leczenia oraz - jeśli to zasadne - receptę i/lub zwolnienie z pracy. Jeżeli chcesz tylko odnowić receptę - powiedz to nam.';
    }
};

export const continueConversation: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Continue chat';
        case 'pl':
            return 'Kontynuuj czat';
    }
};

export const startNewConversation: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Start new conversation';
        case 'pl':
            return 'Rozpocznij nową rozmowę';
    }
};

export const pendingConsultationSubtitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'You have a pending consultation. You must first finish it or cancel it before starting a new one.';
        case 'pl':
            return 'Masz oczekującą konsultację. Musisz najpierw ją zakończyć lub anulować, zanim rozpoczniesz nową.';
    }
};

export const activeConsultationSubtitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'You have an active consultation. You must first finish it before starting a new one.';
        case 'pl':
            return 'Masz aktywną konsultację. Musisz najpierw ją zakończyć, zanim rozpoczniesz nową.';
    }
};

export const goToConsultation: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Go to consultation';
        case 'pl':
            return 'Przejdź do konsultacji';
    }
};
